import type {
  PricingSectionSliceModulesAndAddonsPrimaryAddOnsHeaderItem,
  PricingSectionSliceModulesAndAddonsPrimaryAddOnsItem,
} from 'prismicio-types'
import {AddOnCard} from './AddOnCard'
import {SectionHeader} from './SectionHeader'

type AddOnsSectionProps = {
  header?: PricingSectionSliceModulesAndAddonsPrimaryAddOnsHeaderItem
  addOns: PricingSectionSliceModulesAndAddonsPrimaryAddOnsItem[]
}

export const AddOnsSection = ({header, addOns}: AddOnsSectionProps) => {
  if (!header) {
    return null
  }

  return (
    <div className="flex flex-col gap-12">
      <SectionHeader eyebrow={header.eyebrow} heading={header.heading} description={header.description} />

      {addOns.length > 0 && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {addOns.map((addon, index) => (
            <AddOnCard key={`addon-${index}`} addon={addon} />
          ))}
        </div>
      )}
    </div>
  )
}
